import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-new-skill',
  templateUrl: './new-skill.component.html',
  styleUrls: ['./new-skill.component.scss']
})
export class NewSkillComponent implements OnInit,OnChanges {
  @Input() skill:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;

  user:any
  Form: FormGroup = this.fb.group({
    name: ['', Validators.compose([Validators.required])]
  }); 

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initForm()
  }

  ngOnInit()  
  {    
    setTimeout(()=>{
      this.getUserData()
    },1000)
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  
  getUserData(){
    this.adminApi.setLoader(true)
    this.store.pipe(select(getAdminUserInfo)).subscribe(data=>{
      this.user = data
      this.adminApi.setLoader(false)
    },error=>{
      this.adminApi.setLoader(false)
      this.toastrService.error("unable to handle response");
    })
  }

  initForm(){
    this.Form = this.fb.group({
      name: [this.skill?.name, Validators.compose([Validators.required])]
    });
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      if(this.skill){
        form.value.id=this.skill.id
      }
      this.adminApi.addSkill(form.value).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
          if(!this.skill){
            form.reset();
          }
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      this.adminApi.validateAllFields(form);
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }
  
}
